<template>
  <div class="c-footer" v-if="$route.path.indexOf('/study') < 0 && $route.path.indexOf('/edit') < 0">
    <div class="c-footer-info">
      <i class="iconfont icon-weixin"></i>
      <p class="c-footer-contact">官方公众号</p>
      <img src="/images/code.png" alt="">
    </div>
    <a href="http://www.beian.gov.cn/portal/index.do" target="_blank" class="c-footer-cp">沪ICP备16054094号-1 ©2016-2023 aiimooc.com All Rights Reserved</a>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.c-footer{
  padding-top: 38px;
  height: 180px;
  box-sizing: border-box;
  color: #93979B;
  background-color: #F3F3F3;
  text-align: center;
  .c-footer-info{
    position: relative;
    display: inline-block;
    margin: 0 auto;
    cursor: pointer;
    .icon-weixin{
      font-size: 38px;
      display: inline-block;
      margin-bottom: 6px;
      color: #BCBDBE;
    }
    .c-footer-contact{
      color: #93979B;
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 20px;
    }
    img{
      width: 150px;
      height: 150px;
      border-radius: 4px;
      opacity: 0;
      position: absolute;
      top: -100px;
      left: 50%;
      transform: translate(-50%, -50%);
      transition: all .5s;
      box-shadow: 0px 3px 5px rgba(156, 157, 161, 0.16);
    }
    &:hover img{
      opacity: 1;
      transform: translate(-50%, -45%);
    }
  }
  .c-footer-cp{
    line-height: 22px;
    font-size: 14px;
    color: #93979B;
    text-decoration: none;
    display: block;
  }
}
</style>
